const App = () => import('./App');
import router from './router';
import { store } from './store';

import { VueRegister } from './lib/register';
import { Apollo } from './lib/apollo';
import './lib/check-connection';

import config from './constants/config';
import filters from './constants/filters';
import './lib/firebase';

const Vue = VueRegister();
const apolloProvider = Apollo();
/* eslint-disable no-new */

filters(Vue);
config(Vue);

new Vue({
  el: '#app',
  router,
  apolloProvider,
  store,
  template: '<App/>',
  components: { App },
  data: {
    config,
    filters
  },
  created () {
  }
});



// WEBPACK FOOTER //
// ./src/main.js